import { sipExtensionOwnProvisioningSchema, type SipExtensionOwnProvisioningDto } from '@easyflow/shared';
import { apiClient } from '@/lib/api';
import type { SipPhoneConfig } from '@/lib/sipPhone';

/** One authorized endpoint; no JWT/list fallback after a denial or stale assignment. */
export async function loadOwnSipPhoneConfig(): Promise<SipPhoneConfig | null> {
  const response = await apiClient.get<SipExtensionOwnProvisioningDto | null>('/voip/my-extension');
  if (!response.success) throw new Error('Credenziali del proprio interno non disponibili');
  if (response.data == null) return null;
  const data = sipExtensionOwnProvisioningSchema.parse(response.data);
  return {
    server: data.wss_url,
    extension: data.extension,
    password: data.password,
    domain: data.sip_domain,
    displayName: data.display_name || data.extension,
  };
}
